<template>
  <img :src="src" class="u__img" :alt="src" @click="clickHandle" />
</template>

<script>
import View from './view'
export default {
  props: ['src'],
  methods: {
    clickHandle(e) {
      e.stopPropagation()
      View.show(this.src)
    }
  }
}
</script>

<style>
.v__modal {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99999;
}
.v__img__box {
  max-width: 90%;
  height: 100%;
  overflow: auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
}
.v__img {
  max-height:100%;
}
.u__img{
  cursor: pointer;
}
</style>
